module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-maedori4-6185ebe8612a742f08655627afbc36d6.jpg";